import createItemLevelDataUpdater from './createItemLevelDataUpdater';
import { ClientItem } from 'owa-mail-store';
import { SmartPillLogDataUpdater } from 'owa-smart-pill';

export default function registerSmartPillLogDataUpdaters(
    item: ClientItem
): SmartPillLogDataUpdater[] {
    return [createItemLevelDataUpdater(item)];
}
